// Simple JavaScript Templating
// Adapted from John Resig - http://ejohn.org/ - MIT Licensed

frappe.template = { compiled: {}, debug: {} };
frappe.template.compile = function (str, name) {
	var key = name || str;

	if (!frappe.template.compiled[key]) {
		if (str.indexOf("'") !== -1) {
			str.replace(/'/g, "\\'");
			//console.warn("Warning: Single quotes (') may not work in templates");
		}

		// replace jinja style tags
		str = str.replace(/{{/g, "{%=").replace(/}}/g, "%}");

		// {% if not test %} --> {% if (!test) { %}
		str = str.replace(/{%\s?if\s?\s?not\s?([^\(][^%{]+)\s?%}/g, "{% if (! $1) { %}");

		// {% if test %} --> {% if (test) { %}
		str = str.replace(/{%\s?if\s?([^\(][^%{]+)\s?%}/g, "{% if ($1) { %}");

		// {% for item in list %}
		//       --> {% for (var i=0, len=list.length; i<len; i++) {  var item = list[i]; %}
		function replacer(match, p1, p2, offset, string) {
			var i = frappe.utils.get_random(3);
			var len = frappe.utils.get_random(3);
			return (
				"{% for (var " +
				i +
				"=0, " +
				len +
				"=" +
				p2 +
				".length; " +
				i +
				"<" +
				len +
				"; " +
				i +
				"++) { var " +
				p1 +
				" = " +
				p2 +
				"[" +
				i +
				"]; " +
				p1 +
				"._index = " +
				i +
				"; %}"
			);
		}
		str = str.replace(/{%\s?for\s([a-z._]+)\sin\s([a-z._]+)\s?%}/g, replacer);

		// {% endfor %} --> {% } %}
		str = str.replace(/{%\s?endif\s?%}/g, "{% }; %}");

		// {% else %} --> {% } else { %}
		str = str.replace(/{%\s?else\s?%}/g, "{% } else { %}");

		// {% endif %} --> {% } %}
		str = str.replace(/{%\s?endfor\s?%}/g, "{% }; %}");

		var fn_str =
			"var _p=[],print=function(){_p.push.apply(_p,arguments)};" +
			// Introduce the data as local variables using with(){}
			"with(obj){\n_p.push('" +
			// Convert the template into pure JavaScript
			str
				.replace(/[\r\t\n]/g, " ")
				.split("{%")
				.join("\t")
				.replace(/((^|%})[^\t]*)'/g, "$1\r")
				.replace(/\t=(.*?)%}/g, "',$1,'")
				.split("\t")
				.join("');\n")
				.split("%}")
				.join("\n_p.push('")
				.split("\r")
				.join("\\'") +
			"');}return _p.join('');";

		frappe.template.debug[name] = fn_str;
		try {
			frappe.template.compiled[key] = new Function("obj", fn_str);
		} catch (e) {
			console.log("Error in Template:");
			console.log(fn_str);
			if (e.lineNumber) {
				console.log("Error in Line " + e.lineNumber + ", Col " + e.columnNumber + ":");
				console.log(fn_str.split("\n")[e.lineNumber - 1]);
			}
		}
	}

	return frappe.template.compiled[key];
};
frappe.render = function (str, data, name) {
	return frappe.template.compile(str, name)(data);
};

frappe.render_print_template = function (body, style, options = {}) {
    // Options can include:
    // - printRowByRow: boolean (default: auto-detect)
    // - labelsPerRow: number (default: auto-calculate)
    // - delayBetweenRows: number in ms (default: 1000)
    // - showProgress: boolean (default: true)
    
    const printRowByRow = options.printRowByRow !== undefined 
        ? options.printRowByRow 
        : (body.includes('flex-wrap') && body.includes('fix-height'));
    
    if (printRowByRow) {
        frappe.render_print_template_row_by_row(body, style, options);
    } else {
        frappe.render_print_template_normal(body, style);
    }
};

frappe.render_print_template_normal = function (body, style) {
    // Original implementation for non-bulk formats
    const htmlTemplate = `
        <!DOCTYPE html>
        <html>
        <head>
                ${style}
        </head>
        <body>
            ${body}
        </body>
        </html>
    `;
  
    const printWindow = window.open('', '_blank', 'width=800,height=600');
  
    if (!printWindow) {
        frappe.msgprint(__("Please enable pop-ups in your browser"));
        return;
    }
  
    printWindow.document.write(htmlTemplate);
    printWindow.document.close();
  
    printWindow.onload = function () {
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };
};

frappe.render_pdf_from_template = function (body, style, opts = {}) {
    // Template for the complete HTML content including styles
    const htmlTemplate = `
        <!DOCTYPE html>
        <html>
        <head>
            ${style}
        </head>
        <body>
            ${body}
        </body>
        </html>
    `;

    // Create form data to send HTML to the server
    var formData = new FormData();
    formData.append("html", htmlTemplate);

    // Add optional parameters (e.g., orientation or report name)
    if (opts.orientation) {
        formData.append("orientation", opts.orientation);
    }

    // Create a Blob (empty) for the request
    var blob = new Blob([], { type: "text/xml" });
    formData.append("blob", blob);

    // Send the request to the server for PDF conversion
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "/api/method/frappe.utils.print_format.report_to_pdf");
    xhr.setRequestHeader("X-Frappe-CSRF-Token", frappe.csrf_token);
    xhr.responseType = "arraybuffer";

    xhr.onload = function (success) {
        if (this.status === 200) {
            var blob = new Blob([success.currentTarget.response], { type: "application/pdf" });
            var objectUrl = URL.createObjectURL(blob);

            // Create a hidden a tag to trigger the download
            let hidden_a_tag = document.createElement("a");
            document.body.appendChild(hidden_a_tag);
            hidden_a_tag.style = "display: none";
            hidden_a_tag.href = objectUrl;
            hidden_a_tag.download = opts.report_name || "report.pdf";

            // Trigger the download of the PDF file
            hidden_a_tag.click();
            window.URL.revokeObjectURL(objectUrl);
        }
    };

    xhr.send(formData);
};


frappe.render_template = function (name, data) {
	if (name.indexOf(" ") !== -1) {
		var template = name;
	} else {
		var template = frappe.templates[name];
	}
	if (data === undefined) {
		data = {};
	}
	if (!template) {
		frappe.throw(`Template <b>${name}</b> not found.`);
	}
	return frappe.render(template, data, name);
};
(frappe.render_grid = function (opts) {
	// build context
	if (opts.grid) {
		opts.columns = opts.grid.getColumns();
		opts.data = opts.grid.getData().getItems();
	}

	if (
		opts.print_settings &&
		opts.print_settings.orientation &&
		opts.print_settings.orientation.toLowerCase() === "landscape"
	) {
		opts.landscape = true;
	}

	// show landscape view if columns more than 10
	if (opts.landscape == null) {
		if (opts.columns && opts.columns.length > 10) {
			opts.landscape = true;
		} else {
			opts.landscape = false;
		}
	}

	// render content
	if (!opts.content) {
		opts.content = frappe.render_template(opts.template || "print_grid", opts);
	}

	// render HTML wrapper page
	opts.base_url = frappe.urllib.get_base_url();
	opts.print_css = frappe.boot.print_css;

	(opts.lang = opts.lang || frappe.boot.lang),
		(opts.layout_direction = opts.layout_direction || frappe.utils.is_rtl() ? "rtl" : "ltr");

	var html = frappe.render_template("print_template", opts);

	var w = window.open();

	if (!w) {
		frappe.msgprint(__("Please enable pop-ups in your browser"));
	}

	w.document.write(html);
	w.document.close();
}),
	(frappe.render_tree = function (opts) {
		opts.base_url = frappe.urllib.get_base_url();
		opts.landscape = false;
		opts.print_css = frappe.boot.print_css;
		opts.print_format_css_path = frappe.assets.bundled_asset("print_format.bundle.css");
		var tree = frappe.render_template("print_tree", opts);
		var w = window.open();

		if (!w) {
			frappe.msgprint(__("Please enable pop-ups in your browser"));
		}

		w.document.write(tree);
		w.document.close();
	});

frappe.render_print_template_row_by_row = function (body, style, options = {}) {
    // Default configuration
    const config = {
        delayBetweenRows: options.delayBetweenRows || 1000, // 1 second default
        showProgress: options.showProgress !== false, // true by default
        labelsPerRow: options.labelsPerRow || null, // null = auto-detect
    };
    
    // Parse HTML to extract rows of labels
    const parser = new DOMParser();
    const doc = parser.parseFromString(body, 'text/html');
    
    // Find the container with flex-wrap (the one that holds all labels)
    const flexContainer = doc.querySelector('[style*="flex-wrap"]');
    
    if (!flexContainer) {
        // Fallback to normal printing if structure not found
        console.warn('Could not parse bulk format structure, using normal print');
        frappe.render_print_template_normal(body, style);
        return;
    }
    
    // Extract all label divs (fix-height elements)
    const labelDivs = Array.from(flexContainer.querySelectorAll('.fix-height'));
    
    if (labelDivs.length === 0) {
        frappe.render_print_template_normal(body, style);
        return;
    }
    
    // Get container and label dimensions from styles
    const containerStyle = flexContainer.getAttribute('style') || '';
    const firstLabelStyle = labelDivs[0]?.getAttribute('style') || '';
    
    // Extract widths from styles (e.g., "width: 15cm" or "width: 3cm")
    const containerWidthMatch = containerStyle.match(/width:\s*([\d.]+)\s*cm/);
    const labelWidthMatch = firstLabelStyle.match(/width:\s*([\d.]+)\s*cm/);
    
    let labelsPerRow = config.labelsPerRow;
    
    if (!labelsPerRow) {
        // Auto-calculate labels per row based on dimensions
        if (containerWidthMatch && labelWidthMatch) {
            const containerWidth = parseFloat(containerWidthMatch[1]);
            const labelWidth = parseFloat(labelWidthMatch[1]);
            
            // Account for padding (paper_padding_left from template)
            const paddingLeftMatch = containerStyle.match(/padding-left:\s*([\d.]+)\s*cm/);
            const paddingLeft = paddingLeftMatch ? parseFloat(paddingLeftMatch[1]) : 0;
            
            // Calculate available width (container width minus padding)
            const availableWidth = containerWidth - paddingLeft;
            
            // Calculate how many labels fit (accounting for some margin/gap)
            labelsPerRow = Math.floor(availableWidth / labelWidth);
            
            // Ensure at least 1 label per row
            labelsPerRow = Math.max(1, labelsPerRow);
        } else {
            // Fallback: try to detect rows by checking actual rendered positions
            labelsPerRow = frappe.detect_labels_per_row_dynamically(labelDivs, flexContainer);
        }
    }
    
    // Group labels into rows
    const rows = [];
    for (let i = 0; i < labelDivs.length; i += labelsPerRow) {
        rows.push(labelDivs.slice(i, i + labelsPerRow));
    }
    
    if (config.showProgress) {
        frappe.show_alert({
            message: __('Preparing to print {0} rows ({1} labels)...', [rows.length, labelDivs.length]),
            indicator: 'blue'
        }, 3);
    }
    
    // Store original container for cloning structure
    const originalContainer = flexContainer;
    
    // Print rows sequentially
    frappe.render_print_rows_sequentially(rows, style, originalContainer, 0, rows.length, config);
};

frappe.detect_labels_per_row_dynamically = function (labelDivs, container) {
    // Create a temporary DOM to measure actual rendered positions
    // This is a fallback method when style parsing fails
    
    // Try to infer from the structure
    // If we can't determine, use a conservative default
    const defaultLabelsPerRow = 5; // Common default for 15cm container with 3cm labels
    
    // Check if labels have explicit width in style
    let labelWidth = null;
    let containerWidth = null;
    
    if (labelDivs.length > 0) {
        const labelStyle = labelDivs[0].getAttribute('style') || '';
        const labelWidthMatch = labelStyle.match(/width:\s*([\d.]+)\s*cm/);
        if (labelWidthMatch) {
            labelWidth = parseFloat(labelWidthMatch[1]);
        }
    }
    
    const containerStyle = container.getAttribute('style') || '';
    const containerWidthMatch = containerStyle.match(/width:\s*([\d.]+)\s*cm/);
    if (containerWidthMatch) {
        containerWidth = parseFloat(containerWidthMatch[1]);
    }
    
    if (labelWidth && containerWidth) {
        // Rough calculation (doesn't account for gaps, but gives a starting point)
        return Math.max(1, Math.floor(containerWidth / labelWidth));
    }
    
    return defaultLabelsPerRow;
};

frappe.render_print_rows_sequentially = function (rows, style, originalContainer, currentRowIndex, totalRows, config) {
    if (currentRowIndex >= totalRows) {
        // All rows printed
        if (config.showProgress) {
            frappe.show_alert({
                message: __('Printing completed ({0} rows)', [totalRows]),
                indicator: 'green'
            }, 2);
        }
        return;
    }
    
    // Create a temporary container with only the current row
    const rowLabels = rows[currentRowIndex];
    
    // Clone the original container structure with all attributes
    const rowContainer = originalContainer.cloneNode(false);
    // Preserve the style attribute
    if (originalContainer.getAttribute('style')) {
        rowContainer.setAttribute('style', originalContainer.getAttribute('style'));
    }
    // Preserve class if exists
    if (originalContainer.getAttribute('class')) {
        rowContainer.setAttribute('class', originalContainer.getAttribute('class'));
    }
    rowContainer.innerHTML = '';
    
    // Add only labels from current row
    rowLabels.forEach(label => {
        rowContainer.appendChild(label.cloneNode(true));
    });
    
    // Get the parent structure to maintain proper layout
    const parentDiv = originalContainer.parentElement;
    let rowBody;
    
    if (parentDiv) {
        // Clone parent structure with preserved styles
        const parentClone = parentDiv.cloneNode(false);
        // Preserve parent style
        if (parentDiv.getAttribute('style')) {
            parentClone.setAttribute('style', parentDiv.getAttribute('style'));
        }
        // Preserve class if exists
        if (parentDiv.getAttribute('class')) {
            parentClone.setAttribute('class', parentDiv.getAttribute('class'));
        }
        
        const grandParent = parentDiv.parentElement;
        
        if (grandParent) {
            const grandParentClone = grandParent.cloneNode(false);
            // Preserve grandparent style
            if (grandParent.getAttribute('style')) {
                grandParentClone.setAttribute('style', grandParent.getAttribute('style'));
            }
            // Preserve class if exists
            if (grandParent.getAttribute('class')) {
                grandParentClone.setAttribute('class', grandParent.getAttribute('class'));
            }
            
            grandParentClone.appendChild(parentClone);
            parentClone.appendChild(rowContainer);
            rowBody = grandParentClone.outerHTML;
        } else {
            parentClone.appendChild(rowContainer);
            rowBody = parentClone.outerHTML;
        }
    } else {
        rowBody = rowContainer.outerHTML;
    }
    
    // Create HTML for this row only - use original body structure without extra flex centering
    const htmlTemplate = `
        <!DOCTYPE html>
        <html>
        <head>
            ${style}
        </head>
        <body>
            ${rowBody}
        </body>
        </html>
    `;
    
    // Open print window for this row
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    if (!printWindow) {
        frappe.msgprint(__("Please enable pop-ups in your browser"));
        return;
    }
    
    printWindow.document.write(htmlTemplate);
    printWindow.document.close();
    
    // Update progress
    if (config.showProgress) {
        frappe.show_alert({
            message: __('Printing row {0} of {1}...', [currentRowIndex + 1, totalRows]),
            indicator: 'blue'
        }, 1);
    }
    
    printWindow.onload = function () {
        setTimeout(() => {
            printWindow.print();
            
            // Wait a bit before closing and moving to next row
            // This gives the printer time to process
            setTimeout(() => {
                printWindow.close();
                
                // Delay before printing next row
                setTimeout(() => {
                    frappe.render_print_rows_sequentially(
                        rows, 
                        style, 
                        originalContainer, 
                        currentRowIndex + 1, 
                        totalRows,
                        config
                    );
                }, config.delayBetweenRows);
            }, 500);
        }, 500);
    };
};

frappe.render_pdf = function (html, opts = {}) {
	//Create a form to place the HTML content
	var formData = new FormData();

	//Push the HTML content into an element
	formData.append("html", html);
	if (opts.orientation) {
		formData.append("orientation", opts.orientation);
	}
	var blob = new Blob([], { type: "text/xml" });
	formData.append("blob", blob);

	var xhr = new XMLHttpRequest();
	xhr.open("POST", "/api/method/frappe.utils.print_format.report_to_pdf");
	xhr.setRequestHeader("X-Frappe-CSRF-Token", frappe.csrf_token);
	xhr.responseType = "arraybuffer";

	xhr.onload = function (success) {
		if (this.status === 200) {
			var blob = new Blob([success.currentTarget.response], { type: "application/pdf" });
			var objectUrl = URL.createObjectURL(blob);

			// Create a hidden a tag to force set report name
			// https://stackoverflow.com/questions/19327749/javascript-blob-filename-without-link
			let hidden_a_tag = document.createElement("a");
			document.body.appendChild(hidden_a_tag);
			hidden_a_tag.style = "display: none";
			hidden_a_tag.href = objectUrl;
			hidden_a_tag.download = opts.report_name || "report.pdf";

			// Open report in a new window
			hidden_a_tag.click();
			window.URL.revokeObjectURL(objectUrl);
		}
	};
	xhr.send(formData);
};
